// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__AM-V3","header":"MergedInvoice_header__2CQUX"};